import ReturnVisitorXsell from "./ReturnVisitorXsell";
import Vuex from 'vuex';
import { shallowMount, createLocalVue } from "@vue/test-utils";
import { getObjProperty } from "../../../../../utilities/mrVueUtils";

const localVue = createLocalVue();
localVue.use(Vuex);

let loadCartMock = jest.fn();
let addToCartMock = jest.fn();

function createWrapper(storeObj) {
  let store = new Vuex.Store(storeObj);
  return shallowMount(ReturnVisitorXsell, {
    store,
    localVue,
    provide: {
      getObjProperty
    }
  });
}


function clearMocks() {
  loadCartMock.mockClear();
  addToCartMock.mockClear();
}

let storeObj = {
  modules: {
    cart: {
      namespaced: true,
      state: {
        cart: {
          items: [],
          addons: []
        },
        addingProduct: null
      },

      getters: {
        productIdInCart: jest.fn(),
        subWithSubAttachments: () => {
          return {
            subscription: 4,
            subscriptionAttachments: [
              { code: 'boosts' },
              { code: 'gloss' }
            ]
          };
        }
      },

      actions: {
        loadCart: loadCartMock,
        addToCart: addToCartMock
      }
    }
  }
};

describe('ReturnVisitorXsell', () => {
  describe('computed', () => {
    describe('items', () => {
      let addons = [
        { id: 10 },
        { id: 11 },
        { id: 12 },
        { id: 13 },
        { id: 14 },
        { id: 15 }
      ];

      test('return first three items from cart.addons when cart is empty', () => {
        let localState = {
          cart: { addons },
          productIdInCart: jest.fn((id) => [].includes(id))
        };

        let res = ReturnVisitorXsell.computed.items.call(localState);

        expect(res.length).toBe(3);
        expect(res).toEqual([{ id: 10 }, { id: 11 }, { id: 12 }]);
      });

      test('return first three items from cart.addons after filtering out the ones that are in cart', () => {
        let localState = {
          cart: { addons },
          //- simulate items in cart
          productIdInCart: jest.fn((id) => [11, 12].includes(id))
        };

        let res = ReturnVisitorXsell.computed.items.call(localState);

        expect(res.length).toBe(3);
        expect(res).toEqual([{ id: 10 }, { id: 13 }, { id: 14 }]);
      });
    });
  });

  describe('methods', () => {
    afterEach(() => clearMocks());

    describe('addProductToCart', () => {
      let item = { id: 34 };

      test('payload and expected method call when adding one-time item to cart', () => {
        let wrapper = createWrapper(storeObj);

        let expectedPayload = {
          productId: item.id,
          ctaSource: 'Return Visitor Xsell'
        };

        wrapper.vm.addProductToCart({}, item, false);

        expect(addToCartMock).toHaveBeenCalledTimes(1);
        expect(addToCartMock.mock.calls[0][1]).toEqual(expectedPayload);
      });

      test('payload to contian subscription prop and expected method call when adding attachable to cart', () => {
        let wrapper = createWrapper(storeObj);

        let expectedPayload = {
          productId: item.id,
          ctaSource: 'Return Visitor Xsell',
          subscription: 4
        };

        wrapper.vm.addProductToCart({}, item, true);

        expect(addToCartMock).toHaveBeenCalledTimes(1);
        expect(addToCartMock.mock.calls[0][1]).toEqual(expectedPayload);
      });
    });

    describe('canAttachThisItem', () => {
      test('return true if item can be added as attachable', () => {
        let wrapper = createWrapper(storeObj);
        let item = {
          id: 153,
          productType: 'boosts'
        };

        let res = wrapper.vm.canAttachThisItem(item);
        expect(res).toBe(true);
      });

      test('return false if itme can not be added as attachable', () => {
        let wrapper = createWrapper(storeObj);
        let item = {
          id: 53,
          productCode: 'accessory'
        };

        let res = wrapper.vm.canAttachThisItem(item);
        expect(res).toBe(false);
      });
    });
  });

  describe('mounted', () => {
    afterEach(() => clearMocks());
    test('load cart', () => {
      createWrapper(storeObj);
      expect(loadCartMock).toHaveBeenCalledTimes(1);
    });
  });

});